import { CloseOutlined } from "@ant-design/icons";
import { DatePicker, Dropdown } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

const Period = ({ field, onChange, values, autoOpen }) => {
  const [period, setPeriod] = useState(
    values ? values : { start: null, end: null }
  );
  const [open, setOpen] = useState(autoOpen);

  useEffect(() => {
    if (autoOpen) {
      setOpen(true);
    }
  }, [autoOpen]);

  useEffect(() => {
    const next = values || { start: null, end: null };

    if (
      (period?.start || null) !== (next?.start || null) ||
      (period?.end || null) !== (next?.end || null)
    ) {
      setPeriod(next);
    }
  }, [values?.start, values?.end]);

  const updatePeriod = (date) => {
    if (!date || !date[0] || !date[1]) {
      setPeriod({ start: null, end: null });
      onChange(field.id);
      setOpen(false);
      return;
    }

    const nextPeriod = {
      start: moment(date[0].$d).toISOString(),
      end: moment(date[1].$d).toISOString(),
    };

    setPeriod(nextPeriod);
    onChange(field.id, nextPeriod);
    setOpen(false);
  };

  // A panel, not a menu. Held as a menu item, the date field sits inside a
  // role="menuitem" — and a menu manages focus for its items, which takes it
  // off the input the moment the calendar opens, closing it again.
  const panel = () => (
    <div
      style={{
        background: "#FFFFFF",
        borderRadius: 8,
        padding: 8,
      }}
    >
      <DatePicker.RangePicker
        onChange={(dd) => {
          updatePeriod(dd);
        }}
        format="DD.MM.YYYY"
      />
    </div>
  );

  const openDropdown = () => {
    setOpen(true);
  };

  return (
    <Dropdown
      popupRender={panel}
      styles={{ root: {
        maxHeight: 320,
        overflow: "auto",
        boxShadow: "0px 20px 140px 0px rgba(0, 0, 0, 0.15)",
      } }}
      trigger={["click"]}
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
    >
      <div
        onClick={openDropdown}
        role="presentation"
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "#FFFFFF",
          border: "1px solid #6C6C8929",
          borderRadius: 8,
          padding: "5px 10px",
          fontSize: 14,
          cursor: "pointer",
          maxWidth: "100%",
        }}
      >
        <span style={{ fontWeight: 600 }}>{field.name}: </span>

        <span
          style={{
            color: "rgba(108, 108, 137, 1)",
            marginLeft: 4,
            whiteSpace: "nowrap",
          }}
        >
          {period?.start
            ? `${moment(period.start).utc().format("DD MMM YY")} to ${moment(
                period.end
              )
                .utc()
                .format("DD MMM YY")}`
            : ""}
        </span>

        <div
          style={{
            width: 1,
            height: 16,
            background: "#6C6C89",
            opacity: 0.3,
            borderRadius: 1,
            marginLeft: 8,
            marginRight: 8,
            flexShrink: 0,
          }}
        />

        <span
          style={{
            cursor: "pointer",
            color: "rgba(178, 178, 199, 1)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          onClick={(e) => {
            e.stopPropagation();
            onChange(field.id);
          }}
          role="presentation"
        >
          <CloseOutlined style={{ fontSize: 12 }} />
        </span>
      </div>
    </Dropdown>
  );
};

export default Period;